import { COLORS } from "shared/consts";
import styled from "styled-components";

export const BreadcrumbsContainer = styled.div`
    width: 100%;
    padding: 8px 16px;
    border-bottom: 1px solid ${COLORS.BORDER.SOFT};
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
`

export const Services = styled.div`
    display: flex;
    gap: 8px;
`

export const ServiceButton = styled.div`
    display: flex;
    align-self: center;
    padding: 8px;
    background-color: ${ COLORS.BG.SURFACE1 };
    border-radius: 0.75rem;
    cursor: pointer;
    transition: all 0.25s;
    
    &:hover {
        scale: 1.03;
    }
`

export const ServiceButtonText = styled.div`
    display: flex;
    align-self: center;
    margin-left: 4px;
    font-size: medium;
    font-weight: 500;
`
